/**
 * Globally accessible components
 */
const Accordion = () => import('./global/common/Accordions/Accordion.vue');
const AddToCart = () => import('./cart/buttons/AddToCart.vue');
const AddToCartChecklist = () => import('./cart/buttons/AddToCartChecklist.vue');
const AddPlaylistModal = () => import('./playlist/AddPlaylistModal.vue');
const BackingTrackPlayer = () => import('./BackingTrackPlayer.vue');
const CardColumnPanel = () => import('./CardColumnPanel.vue');
const CardPanel = () => import('./CardPanel.vue');
const CartDropdown = () => import('./cart/dropdown/Dropdown.vue');
const Coupon = () => import('./cart/inputs/Coupon.vue');
const CourseMasthead = () => import('./CourseMasthead.vue');
const DeliveryAddress = () => import('./cart/steps/DeliveryAddress.vue');
const FreeDvdComponent = () => import('./checkout/FreeDvdComponent.vue');
const GridListIndex = () => import('./GridListIndex.vue');
const CarouselList = () => import('./CarouselList.vue');
const GiftModal = () => import('./gifts/GiftModal.vue');
const GiftModalButton = () => import('./gifts/GiftModalButton.vue');
const Hidden = () => import('./video-section/hidden.vue');
const IndexMastheadFilters = () => import('./common/masthead/IndexMastheadFilters.vue');
const Intersect = () => import('./Intersect.vue');
const MastheadCounter = () => import('./playlist/MastheadCounter.vue');
const MastheadFilters = () => import('./common/masthead/MastheadFilters.vue');
const NextStep = () => import('./checkout/NextStep.vue');
const NewPlaylist = () => import('./playlist/NewPlaylist.vue');
const NotificationList = () => import('./NotificationList.vue');
const Onboarding = () => import('./sign-up/Onboarding.vue');
const PayComponent = () => import('./checkout/PayComponent.vue');
const PaymentComponent = () => import('./cart/steps/PaymentComponent.vue');
const Player = () => import('./video-section/player.vue');
const PlaylistPanelGroup = () => import('./playlist/PlaylistPanelGroup.vue');
const PlayTrailerButton = () => import('./PlayTrailerButton.vue');
const PreviewModal = () => import('./sign-up/PreviewModal.vue');
const ProductModal = () => import('./ProductModal.vue');
const Profile = () => import('../pages/Profile/Profile.vue');
const ReadMore = () => import('./helpers/ReadMore.vue');
const RemoveFromCart = () => import('./cart/buttons/RemoveFromCart.vue');
const SaleCountdownTimer = () => import('./SaleCountdownTimer.vue');
const Search = () => import('./search/Search.vue');
const SearchToggle = () => import('./search/SearchToggle.vue');
const SwiperCarousel = () => import('./SwiperCarousel.vue');
const ToggleCreatePlaylist = () => import('./playlist/ToggleCreatePlaylist.vue');
const ToggleWatchlistButton = () => import('./playlist/ToggleWatchlistButton.vue');
const UseLoyaltyComponent = () => import('./checkout/UseLoyaltyComponent.vue');
const UserNameLabel = () => import('./UserNameLabel.vue');
const VideoSection = () => import('./video-section/video-section.vue');
const VideoSectionButtons = () => import('./video-section/buttons.vue');
const VideoSectionVideo = () => import('./video-section/sections/video.vue');
const NewsletterSignup = () => import('./NewsletterSignup.vue');

Vue.component('Accordion', Accordion);
Vue.component('AddToCart', AddToCart);
Vue.component('AddToCartChecklist', AddToCartChecklist);
Vue.component('AddPlaylistModal', AddPlaylistModal);
Vue.component('BackingTrackPlayer', BackingTrackPlayer);
Vue.component('CardColumnPanel', CardColumnPanel);
Vue.component('CardPanel', CardPanel);
Vue.component('CartDropdown', CartDropdown);
Vue.component('Coupon', Coupon);
Vue.component('CourseMasthead', CourseMasthead);
Vue.component('DeliveryAddress', DeliveryAddress);
Vue.component('FreeDvdComponent', FreeDvdComponent);
Vue.component('GiftModal', GiftModal)
Vue.component('GiftModalButton', GiftModalButton);
Vue.component('GridListIndex', GridListIndex);
Vue.component('CarouselList', CarouselList);
Vue.component('HiddenVideoSection', Hidden);
Vue.component('IndexMastheadFilters', IndexMastheadFilters);
Vue.component('Intersect', Intersect);
Vue.component('MastheadCounter', MastheadCounter);
Vue.component('MastheadFilters', MastheadFilters);
Vue.component('NextStep', NextStep);
Vue.component('NewPlaylist', NewPlaylist);
Vue.component('NotificationList', NotificationList);
Vue.component('Onboarding', Onboarding);
Vue.component('PayComponent', PayComponent);
Vue.component('PaymentComponent', PaymentComponent);
Vue.component('Player', Player);
Vue.component('PlaylistPanelGroup', PlaylistPanelGroup);
Vue.component('PlayTrailerButton', PlayTrailerButton);
Vue.component('PreviewModal', PreviewModal);
Vue.component('ProductModal', ProductModal);
Vue.component('Profile', Profile);
Vue.component('ReadMore', ReadMore);
Vue.component('RemoveFromCart', RemoveFromCart);
Vue.component('SaleCountdownTimer', SaleCountdownTimer);
Vue.component('Search', Search);
Vue.component('SearchToggle', SearchToggle);
Vue.component('SwiperCarousel', SwiperCarousel);
Vue.component('ToggleCreatePlaylist', ToggleCreatePlaylist);
Vue.component('ToggleWatchlistButton', ToggleWatchlistButton);
Vue.component('UseLoyaltyComponent', UseLoyaltyComponent);
Vue.component('UserNameLabel', UserNameLabel);
Vue.component('VideoSection', VideoSection);
Vue.component('VideoSectionButtons', VideoSectionButtons);
Vue.component('VideoSectionVideo', VideoSectionVideo);
Vue.component('NewsletterSignup', NewsletterSignup);
Vue.component('NewsletterSignup', NewsletterSignup);

import {BModal} from 'bootstrap-vue';
Vue.component('BModal', BModal);
